import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class BookingDetails extends Component {

validateForm(){
  return true;
}

constructor(props){
  super(props);
  //Status  ?payment_id=MOJO9117G05A01146127&status=successs
  var txnId = "";
  var txnStatus = "";
  var tokens = this.props.history.location.search.split("=");

  if(tokens && tokens.length === 3){
    txnStatus = tokens[2];
    txnId = tokens[1].split("&")[0];
  }

  this.state = {
      isLoading: false,
      fullname : "",
      age: "",
      otherpersonname: "",
      gender: "Male",
      medicalregno: "",
      hospital: "",
      delegatetype: "Presenter",
      food: "Vegetarian",
      errorMsg: "",
      txnId: txnId,
      txnStatus: txnStatus

  };


}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });

}


submitPersonalDetails = async event => {
    event.preventDefault();

    var bookingdetails = {};

    try{
      var isAnythingChanged = false;
      if(this.state.fullname.length === 0){
        this.setState({errorMsg: "Please enter your name"});
        return;
      }

      if(this.state.age.length === 0){
        this.setState({errorMsg: "Please enter your age"});
        return;
      }


      if(this.state.medicalregno.length === 0){
        this.setState({errorMsg: "Please enter the medical counsil registration number"});
        return;
      }

      if(this.state.hospital.length === 0){
        this.setState({errorMsg: "Please enter the hosptial where you work"});
        return;
      }

      if(this.state.otherpersonname.length === 0){
        this.state.otherpersonname = "Single Occupancy";
      }

      await this.createBooking(this.state);

      this.setState({isLoading: false, successMsg: "Successfully updated your booking details."});


    }catch(e){

      this.setState({isLoading: false, errorMsg: "Something went wrong. Please contact our support team."});
    }
 }

  createBooking(bookingDetails){
    return API.post("retnetindia", "/register4retnet", {
      body: bookingDetails
    })
  }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

render() {

    return(
      <div className="container">
      <div class="alert alert-success retnet-center-text" role="alert">
          Thank you for signing up for Retnet India Meet 2019.
      </div>
        <br />
        <div className="row ">
            <div className="col-md-1"></div>
            <div className="col-md-10">
                <div className="row">
                  <div className="col-md-10 profile-udpate-widget">
                    <div className="card">
                      <div className="card-title b-xs-bottom">
                          <h3 className="retnet-center-text">RETNET INDIA MEET 2019</h3>
                          <p className="retnet-center-text">Please submit below details so that we can arrange your stay for the conference</p>

                      </div>
                      <div className="card-body">
                          {this.getErrorElement()}
                          {this.getSuccessNotification()}
                          <form id="personal-details-form"
                                onSubmit={this.submitPersonalDetails}>
                                <div className="row">
                                    <div className="col-md-6">
                                          <div className="form-group">
                                              <label for="fullname">Full Name</label>
                                              <input type="text" id="fullname"
                                                   className="form-control"
                                                   placeholder=""
                                                   onChange={this.handleChange} />
                                          </div>
                                    </div>
                                    <div className="col-md-6">
                                          <div className="form-group">
                                              <label for="gender">Select Gender</label>
                                              <select className="form-control"
                                                      id="gender"
                                                      onChange={this.handleChange}>
                                                  <option value="Female">Female</option>
                                                  <option value="Male">Male</option>

                                              </select>
                                          </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                          <div className="form-group">
                                              <label for="age">Age</label>
                                              <input type="number" id="age"
                                                   className="form-control"
                                                   placeholder=""
                                                   onChange={this.handleChange} />
                                          </div>
                                    </div>
                                    <div className="col-md-6">
                                          <div className="form-group">

                                          </div>
                                    </div>
                                </div>
                                <br />

                                <h3>If Double Occupancy</h3>
                                <div className="row">
                                    <div className="col-md-6">
                                          <div className="form-group">
                                              <label for="otherpersonname">Preferred other person name </label>
                                              <input type="text" id="otherpersonname"
                                                   className="form-control"
                                                   placeholder=""
                                                   onChange={this.handleChange} />
                                          </div>
                                    </div>
                                    <div className="col-md-6">
                                          <div className="form-group">
                                            <label for="otherpersonname">Preferred other person mobile number </label>
                                            <input type="text" id="otherpersonmobileno"
                                                 className="form-control"
                                                 placeholder=""
                                                 onChange={this.handleChange} />


                                          </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label for="medicalregno">Medical Council Reg No</label>
                                            <input type="text" id="medicalregno"
                                                 className="form-control"
                                                 placeholder=""
                                                 onChange={this.handleChange} />
                                        </div>

                                    </div>
                                    <div className="col-md-6">

                                        <div className="form-group">
                                            <label for="hospital">Working Hospital</label>
                                            <input type="text" id="hospital"
                                                 className="form-control"
                                                 placeholder=""
                                                 onChange={this.handleChange} />
                                        </div>

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label for="food">Food Preference</label>
                                            <select className="form-control"
                                                    id="food"
                                                    onChange={this.handleChange}>
                                                <option value="Vegetarian">Vegetarian</option>
                                                <option value="NonVegetarian">Non Vegetarian</option>

                                            </select>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">

                                        </div>

                                    </div>
                                </div>



                                <br />
                                <div className="form-group align-center">

                                    <LoaderButton block bsStyle="primary" bsSize="large"
                                          disable={!this.validateForm()} type="submit"
                                          isLoading={this.state.isLoading} text=" Submit "
                                          loadingText="Updating Details..."
                                          className="btn btn-primary"/>
                                </div>


                          </form>

                      </div>
                  </div>
              </div>
            </div>
            <div className="col-md-1"></div>
        </div>
      </div>
      <br />
      <br />
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BookingDetails.js